import { appEntry } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-3">
          移动端看片新体验
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-xl mx-auto">
          91免费看片神器，手机浏览器打开即用，无需下载安装
        </p>
        <div className="flex flex-col lg:flex-row items-center gap-10 max-w-4xl mx-auto">
          <div className="flex-1">
            <h3 className="text-xl md:text-2xl font-bold font-heading text-foreground-900 mb-3">
              {appEntry.title}
            </h3>
            <p className="text-base text-foreground-600 mb-4 leading-relaxed">
              {appEntry.subtitle}
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed mb-5">
              {appEntry.description}
            </p>
            <div className="grid grid-cols-2 gap-3">
              {appEntry.features.map((f) => (
                <div key={f} className="flex items-center gap-2 text-sm text-foreground-700">
                  <i className="ri-checkbox-circle-fill text-primary-500 text-base"></i>
                  <span>{f}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="flex-1 w-full max-w-sm">
            <div className="w-full aspect-[4/5] rounded-lg overflow-hidden">
              <img
                src={appEntry.imageUrl}
                alt="91免费看片神器手机版界面"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}